import {
  BATHROOM_CABINET_BOX_PART_IDS,
  CABINET_BOXES,
  KITCHEN_CABINET_BOX_PART_IDS,
} from "../constants";
import {MINIMUM_TALL_CABINET_HEIGHT} from "./sqftCabinetsDataMapper";

// Cabinet shapes can store the box part on either partId or parentPartId,
// depending on whether the shape came from a feature group or a box group.
export function getCabinetBoxPartId(shape) {
  if (!shape) {
    return null;
  }

  return [shape.partId, shape.parentPartId]
    .find(partId => CABINET_BOXES.includes(partId)) || null;
}

export function areKitchenCabinetBoxes(firstShape, secondShape) {
  return KITCHEN_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(firstShape))
    && KITCHEN_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(secondShape));
}

export function areBathroomCabinetBoxes(firstShape, secondShape) {
  return BATHROOM_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(firstShape))
    && BATHROOM_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(secondShape));
}

export function isTallCabinetBox(shape) {
  if (!KITCHEN_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(shape))) {
    return false;
  }

  return typeof shape.getInitialHeight === 'function'
    && shape.getInitialHeight() > MINIMUM_TALL_CABINET_HEIGHT;
}

// Tall cabinets occupy both upper and lower cabinet lanes, so they can share
// shuffle/placement runs with either lane. Regular upper/lower cabinets cannot.
export function canCabinetBoxesShareRun(firstShape, secondShape) {
  if (areBathroomCabinetBoxes(firstShape, secondShape)) {
    return true;
  }

  if (!areKitchenCabinetBoxes(firstShape, secondShape)) {
    return false;
  }

  return getCabinetBoxPartId(firstShape) === getCabinetBoxPartId(secondShape)
    || isTallCabinetBox(firstShape)
    || isTallCabinetBox(secondShape);
}
